import { API, Endpoints } from '@brg/api';

export function getCardsByTeam(
  page: number,
  limit: number,
  teamId: string,
  sort: string,
  sendOpts?: { signal?: AbortSignal }
) {
  return API.request()
    .endpoint(Endpoints.cardsMnePw)
    .url('/api/Products/GetList')
    .get()
    .addQuery('page', page)
    .addQuery('limit', limit)
    .addQuery('sort', sort)
    .addQuery('teamId', teamId)
    .addQuery('isHidden', 'false')
    .addQuery('enableContextConditions', 'true')
    .send(sendOpts?.signal ? { signal: sendOpts.signal } : {})
    .then((r) => r.json());
}
import { API, Endpoints } from '@brg/api';

export function getCardsByTeam(
  page: number,
  limit: number,
  teamId: string,
  sort: string,
  sendOpts?: { signal?: AbortSignal }
) {
  return API.request()
    .endpoint(Endpoints.cardsMnePw)
    .url('/api/Products/GetList')
    .get()
    .addQuery('page', page)
    .addQuery('limit', limit)
    .addQuery('sort', sort)
    .addQuery('teamId', teamId)
    .addQuery('isHidden', 'false')
    .addQuery('enableContextConditions', 'true')
    .send(sendOpts?.signal ? { signal: sendOpts.signal } : {})
    .then((r) => r.json());
}
